import { ID } from '@griply/types';
import { useQueries, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import {
  createExternalConnectionCalendarsQueryFn,
  queryKey,
} from './use-external-connection-calendars-query';

export type { ConnectionCalendar } from '@griply/types';

export type UseExternalConnectionsCalendarsQueriesOptions = {
  enabled?: boolean;
};

export const useExternalConnectionsCalendarsQueries = (
  connectionIds: ID[],
  { enabled = true }: UseExternalConnectionsCalendarsQueriesOptions = {},
) => {
  const queryClient = useQueryClient();
  const queries = useQueries({
    queries: connectionIds.map((id) => ({
      queryKey: [queryKey, id],
      queryFn: createExternalConnectionCalendarsQueryFn(queryClient, id),
      // pending would suspend the root-mounted EventFormProvider and blank the app shell
      placeholderData: null,
      enabled,
    })),
  });

  const calendars = useMemo(
    () =>
      queries.flatMap((query, index) =>
        (query.data?.calendars ?? []).map((calendar) => ({
          ...calendar,
          connectionId: connectionIds[index],
        })),
      ),
    [queries, connectionIds],
  );

  return {
    calendars,
    isPending: queries.some((query) => query.isPlaceholderData),
  };
};
